import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, Input, Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';

class InputWithDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: props.showDropdown ?? false,
    };
  }

  handleVisibleChange = (open) => {
    this.setState({ open });
  };

  handleSelect = (value, option) => {
    const { onSelectItem } = this.props;
    if (onSelectItem) {
      onSelectItem(option.payload);
    }
    this.setState({ open: false });
  };

  render() {
    const {
      listItems,
      loading,
      caret = true,
      showDropdown, // only used for initial state
      onChange,
      ...inputProps
    } = this.props;

    const { open } = this.state;

    const options = listItems.map((item, index) => ({
      value: item.description.trim() || '',
      label: item.description.trim() || '',
      payload: item,
      key: item.id || index,
    }));

    return (
      <AutoComplete
        open={open}
        options={options}
        style={{ width: '100%' }}
        onSelect={this.handleSelect}
        onChange={onChange}
        // ⬇️ new props
        onOpenChange={this.handleVisibleChange}
        popupMatchSelectWidth
        styles={{
          popup: {
            root: {
              zIndex: 1000,
              boxShadow: '0px 6px 12px 0px rgba(0,0,0,0.176)',
              border: '1px solid #e7eaec',
            },
          },
        }}
        notFoundContent={loading ? <Spin size="small" /> : 'No Suggestions'}
        filterOption={(input, option) =>
          option?.value?.toLowerCase().includes(input.toLowerCase())
        }
      >
        <Input
          {...inputProps}
          size="small"
          onFocus={() => this.setState({ open: true })}
          suffix={caret ? <DownOutlined /> : null}
        />
      </AutoComplete>
    );
  }
}

InputWithDropdown.propTypes = {
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,         // your JSON actually uses description; you can adjust if you want
    })
  ).isRequired,
  showDropdown: PropTypes.bool,
  caret: PropTypes.bool,
  loading: PropTypes.bool,
  onSelectItem: PropTypes.func.isRequired,
};

InputWithDropdown.defaultProps = {
  showDropdown: false,
  caret: true,
  loading: false,
};

export default InputWithDropdown;
